import React, { useEffect } from "react";
import { Modal } from "react-bootstrap";
import Markdown from 'react-markdown';
import { connect, useDispatch } from "react-redux";
import i18n from "../../I18n";
import LoadMoreSpinner from "component/common/LoadMoreSpinner";
import { getTranslationField } from "utils";
import "./LevelRuleModal.scss";

const SingleLevelRule = ({
  title,
  content,
}) => (
  <div>
    <div className="level-rule-second-title subheading">
      {title}
    </div>
    <div className="level-rule-detail-message body-1">
      <Markdown>{content}</Markdown>
    </div>
  </div>
)

const LevelRuleModal = ({
  language,
  levelRules,
  levelRulesLoading,
  showLevelRule,
  handleOnHide,
}) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch({ type: 'levels/fetchLevelRules' });
  }, []);

  return (
    <Modal
      centered
      show={showLevelRule}
      onHide={handleOnHide}
      className="level-rule-modal"
    >
      <Modal.Header>
        <div className="level-rule-title title-medium-1">{i18n.t("levelRules")}</div>
        <button
          onClick={handleOnHide}
          className="level-rule-close-btn"
        >
          <img
            alt="close"
            src="/profile/close.png"
            srcSet="/profile/close@2x.png 2x, /profile/close@3x.png 3x"
          />
        </button>
      </Modal.Header>
      <Modal.Body>
        {
          levelRulesLoading
            ? <div className="level-rule-modal-loading">
              <LoadMoreSpinner />
            </div>
            : <>
              {
                levelRules?.map((rule, index) => (
                  <SingleLevelRule
                    key={rule.id}
                    title={getTranslationField(rule, "title", language)}
                    content={getTranslationField(rule, "content", language)}
                  />
                ))
              }
            </>
        }
      </Modal.Body>
    </Modal>
  );
}

const mapStateToProps = (state) => ({
  language: state.users.language,
  levelRules: state.levels.levelRules,
  levelRulesLoading: state.levels.levelRulesLoading,
})

export default connect(mapStateToProps)(LevelRuleModal);
